<template>
  <a
    :href="`#${tab.key}`"
    class="navigation-tab"
    :class="{ 'active': active }"
    @click="$emit('click', tab)"
  >
    <div class="icon-container">
      <cs-icon :name="tab.icon" :color="iconColor" />
    </div>
    <div class="help-link-container">
      <help-link v-if="isShownHelpLink" :source="tab.helpLink" />
    </div>
    <div class="label">{{ $t(tab.label) }}</div>
  </a>
</template>

<script>
import HelpLink from 'molecules/HelpLink';

const ACTIVE_ICON_COLOR = '#fff';
const INACTIVE_ICON_COLOR = '#212121';

export default {
  name: 'NavigationTab',
  components: {
    HelpLink,
  },
  props: {
    tab: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    iconColor() {
      return this.active ? ACTIVE_ICON_COLOR : INACTIVE_ICON_COLOR;
    },
    isShownHelpLink() {
      return this.active && this.tab.help;
    },
  },
};
</script>

<style lang="sass" scoped>
  .navigation-tab
    min-width: 120px
    height: 110px
    position: relative
    display: flex
    flex-direction: column
    justify-content: space-between
    padding: 15px
    background: #27283C
    border-radius: 5px
    border: 1px solid transparent
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    box-sizing: border-box
    cursor: pointer

    &:hover
      background: #2E3048
      border-color: #43455A

    &.active
      background: #2E3048
      border-color: #43455A
      cursor: default

    +respond-to('small')
      padding: 20px

  .icon-container
    width: 40px
    height: 40px
    flex: none
    display: flex
    justify-content: center
    align-items: center
    background: #fff
    border-radius: 50%

    #{'.active'} &
      background: #9B51E0

  .help-link-container
    width: 20px
    height: 20px
    position: absolute
    top: 21px
    right: 17px

  .label
    font-size: 12px
    font-weight: 400
    line-height: 18px
    white-space: nowrap
    margin-bottom: -3px

    #{'.active'} &
      font-weight: 500

      +respond-to('medium')
        font-weight: 600
</style>
